<app-popup id="showMore" [overrideOutsideClick]="true">
  <section class="flu-details">
    <div class="flu-details__img" [ngStyle]="{ 'background-image': 'url(' + imgUrl + ')', height: imgHeight + 'px' }"></div>
    <div class="flu-details__text">
      <h3 class="flu-details__title" [innerHtml]="title"></h3>
      <p class="flu-details__description" [innerHTML]="description"></p>
    </div>
    <ods-button variant="tertiary" (click)="close()">
      CLOSE WINDOW
      <ods-icon slot="icon" variant="close"></ods-icon>
    </ods-button>
  </section>
</app-popup>
